/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path axios
 * @description Axios interceptor for not logged user
 */
import axios from "axios";
export default {
  setupInterceptors: () => {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          window.location.reload();
        }
        return Promise.reject(error);
      }
    );
  },
};
